import React from 'react';
import { Button, Col, FormControl, Modal, Row } from 'react-bootstrap';
import './PurchaseBanner.scss';
import FaqLine from '../img/banner/faqline.png';
import Line from '../img/purchaseBannerModal/Line.png';
import Success from '../img/purchaseBannerModal/Success.png';
import Steps from 'rc-steps';
import {parseError, getWalletData, updateWallet} from '../utils/helper';
import RightArrow from '../img/LotteryBanner/arrow-right.png'

export default function PurchaseBanner(props) {
    const [currentPurchaseStep, setCurrentPurchaseStep] = React.useState(0);
    const [showPurchaseModel, setShowPurchaseModel] = React.useState(false);
    const [purchaseSuccess, setPurchaseSuccess] = React.useState(false);
    const [usdtBalance, setUsdtBalance] = React.useState(5000); // TODO:- get wallet balance from api
    const [solrBalance, setSolrBalance] = React.useState(0); // TODO:- get wallet balance from api
    const [eligibleToBuySolr, setEligibleToBuySolr] = React.useState(true);
    const [inputAmmount, setInputAmmount] = React.useState(500);
    const [error, setError] = React.useState(false);
    const [maxError, setMaxError] = React.useState(false);
    const [minError, setMinError] = React.useState(false);
    const [purchaseErrorMessage, setPurchaseErrorMessage] = React.useState('');
    const [showPurchaseSteps, setShowPurchaseSteps] = React.useState(false);
    const [isPurchaseDone, setIsPurchaseDone] = React.useState(false);

    const UsdtBalanceFunc = () => { // for mock data
        var Usdt = Math.floor(Math.random() * 5001);
        setUsdtBalance(Usdt);
    }

    const SolrBalanceFunc = () => { // for mock data
        var Solr = Math.floor(Math.random() * 1001);
        setSolrBalance(Solr);
    } 

    const [willRecieveSolr, setWillRecieveSolr] = React.useState(5000);
    const youWillRecieve = (value) => {
        let solr = value * 10
        setWillRecieveSolr(solr <= 0 ? 0 : solr); 
    }

    const isEligible = (amt) => {
        return amt + solrBalance <= 5000 
    }


    const handelInput = (value) => {
        youWillRecieve(value)
        setPurchaseErrorMessage('');
        if(value > usdtBalance) {
            setError(true);
        } else {
            setError(false);
        }

        if(value > 500) {
            setMaxError(true)
        } else {
            setMaxError(false)
        }

        if(value < 100) {
            setMinError(true)
        } else {
            setMinError(false)
        }

        setEligibleToBuySolr(isEligible(value * 10));

        setInputAmmount(value);
    }

    React.useEffect(async () => {
        if(props.walletAddress) {
            setCurrentPurchaseStep(1); 
            // const walletData = await getWalletData(props.walletAddress);
            const walletData = {};
            if (!walletData.purchase) {
                setShowPurchaseSteps(true);
            } else {
                setIsPurchaseDone(true);
            }
        }
    }, [props.walletAddress])

    return (
        <div className="purchase-main">
            <div className="purchase-layout">
                <div className="container">
                <Row className="purchase-desktop-view">
                    <Col>
                        <div>
                            <div className="purchase-heading">
                                Purchase
                                <br />
                                <span className="purchase-heading-2">
                                    SOLR
                                </span>
                            </div>
                            <div className="faqs-tcs-div">
                                <span className="faqs">FAQs</span>
                                <span>
                                    <img src={FaqLine} alt="line24" />
                                </span>
                                <span className="tcs">T&Cs</span>
                            </div>
                            <div className="purchase-msg">
                                <p className="msg-text">* Only whitelisted and successfully KYCed users are allowed to participate</p>
                            </div>
                        </div>
                    </Col>
                    <Col>
                        <div>
                            {!isPurchaseDone && setShowPurchaseSteps && <div className="lottery-stepper-align">
                                <div className="lottery-stepper">
                                    <Steps current={currentPurchaseStep} direction="horizontal">
                                        <Steps.Step className="step-1" />
                                        <Steps.Step className="step-2" />
                                    </Steps>
                                </div>
                            </div>}

                            {currentPurchaseStep === 0 && 
                                <>
                                    <div className="lottery-won">
                                        <h1 className="lottery-won-sub-text">Connect your wallet before you proceed <br /> to purchase</h1>
                                    </div>
                                    <div className="lottery-connect-btn-div">
                                        <Button
                                            onClick={() => {
                                                props.connectToWallet();
                                            }}
                                            className="purchase-connect-btn btn-transform btn-lin-grad lottery-shine">
                                            Connect Wallet
                                            <span className="purchase-hover"><img src={RightArrow} alt="rignt-arro" /></span>
                                        </Button>
                                    </div>
                                </>
                            }

                            {currentPurchaseStep === 1 && showPurchaseSteps && !isPurchaseDone && 
                                <>
                                    <div className="lottery-won">
                                        <h1 className="lottery-won-sub-text">Click on the button below to <br /> purchase SOLR</h1>
                                    </div>
                                    <div className="lottery-connect-btn-div">
                                        <Button
                                            onClick={() => {
                                                // UsdtBalanceFunc();
                                                // SolrBalanceFunc();
                                                setShowPurchaseModel(true);
                                            }}
                                            className="purchase-connect-btn btn-transform btn-lin-grad">
                                            Purchase
                                        </Button>
                                    </div>
                                </>
                            }

                        {isPurchaseDone && 
                                <div style={{marginTop: '120px'}}>
                                    <div className="lottery-won">
                                        <h1 className="lottery-won-sub-text" style={{fontSize: '24px'}}>You've already purchased!</h1>
                                    </div>
                                </div>
                            }
                        </div>
                    </Col>
                </Row>

                <Row className="purchase-mobile-view">
                    <Col>
                        <div className="purchase-mobile">
                            Purchase is supported
                            <br />
                            only on Desktop
                        </div>
                    </Col>
                </Row>
                </div>
            </div>
            
            {/* purchase model start */}
            <>
                <Modal
                    show={showPurchaseModel}
                    onHide={() => setShowPurchaseModel(false)}
                    centered
                    className="purchase-banner-model"
                    dialogClassName="modal-90w"
                    aria-labelledby="example-custom-modal-styling-title"
                >
                    <Modal.Header closeButton />
                    <Modal.Body>
                        { !purchaseSuccess && 
                            <div className="purchasebanner-model-content-div">
                                {/* <div className="purchasebanner-model-content-currency">
                                    <span className="balance-usdt">Your Balance: {usdtBalance} USDT</span>
                                    <span><img src={Line} alt="line6" /></span>
                                    <span className="balance-1000">{solrBalance} SOLR</span>
                                </div> */}
                                <div className="purchasebanner-model-content">
                                    <div className="purchasebanner-model-main-content">
                                        <div className="purchasebanner-modelcontent-1">
                                            <div className="purchase-content-padding-1">
                                                <div className="purchase-amt">
                                                    Purchase Amount
                                                </div>
                                                <div className="input-div">
                                                    <Button onClick={() => {
                                                        setInputAmmount(500);
                                                        handelInput(500);
                                                        }} 
                                                        className="purchase-max-btn btn-transform">
                                                            <div className="btn-max">Max</div>
                                                        </Button>
                                                    <FormControl
                                                        onChange={(e) => handelInput(e.target.value)}
                                                        value={inputAmmount}
                                                        maxLength="3"
                                                        type="number"
                                                        className="custom-form-control"
                                                        aria-label="Recipient's username"
                                                        aria-describedby="basic-addon2"
                                                    />
                                                    <span className="unit-usdt">
                                                        USDT
                                                    </span>
                                                </div>
                                                <div className="min-max-amt">
                                                    Min: 100 USDT<span style={{ marginLeft: '8px' }}>Max: 500 USDT</span>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="purchasebanner-modelcontent-2">
                                            <div>
                                                <h6 className="will-recieve">You will receive<span className="solr-amt-txt"> { willRecieveSolr} $SOLR</span></h6>
                                            </div>
                                            <div>
                                                <Button
                                                    // disabled={ error || maxError || minError || !inputAmmount || !eligibleToBuySolr }
                                                    onClick={async () => {
                                                        // const walletData = await getWalletData(props.walletAddress);
                                                        const walletData = {bucketId: 'AiCUYrXfwjvRAWfrkgbZ6kjW4voLvPY1TFS6f1V9Spf'};
                                                        console.log('wallet data from api', walletData);
                                                        if (!walletData.bucketId) {
                                                            setPurchaseErrorMessage('Purchase failed without a valid bucket Id, please contact support');
                                                            return;
                                                        }

                                                        props.ExecuteTokenSaleWithUserWallet(props.selectedWallet, inputAmmount, walletData.bucketId).then(async () => {
                                                            // await updateWallet(props.walletAddress); // update purchase status
                                                            setPurchaseSuccess(true);
                                                            setIsPurchaseDone(true);
                                                        }, async (error) => {
                                                            // error case need to render a message in modal?
                                                            console.log('Purchase failed!', error);
                                                            setPurchaseErrorMessage(parseError(error.message));
                                                        });

                                                    }} 
                                                    className="purchase-modal-btn"
                                                >
                                                    Purchase
                                                </Button>
                                                { error && !maxError && !minError &&
                                                    <div>
                                                        <p className="error-msg">You don’t have enough balance</p>
                                                    </div>
                                                }
                                                {/* TODO: Uncomment and enable validations */}
                                                {/* { maxError &&
                                                    <div>
                                                        <p className="error-msg">Max limit reached</p>
                                                    </div>
                                                }

                                                { minError &&
                                                    <div>
                                                        <p className="error-msg">Minimum 100USDT</p>
                                                    </div>
                                                } */}

                                                { !eligibleToBuySolr && !error && !maxError && !minError &&
                                                    <div>
                                                        <p className="error-msg">You can buy only {5000 - solrBalance} SOLR</p>
                                                    </div>
                                                }

                                                { purchaseErrorMessage && 
                                                    <div>
                                                        <p className="error-msg">{`Sorry, ${purchaseErrorMessage}`}</p> 
                                                    </div>
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        }

                        { purchaseSuccess &&
                            <div>
                                <div className="success-img">
                                    <span>
                                        <img src={Success} alt="Success" />
                                    </span>
                                </div>
                                <div className="purchase-success">
                                    Purchase Successful
                                </div>
                                <div className="credit-created">
                                    {inputAmmount * 10} SOLR credited to your wallet
                                </div>
                            </div>
                        }
                    </Modal.Body>
                </Modal>
            </>
        </div>
    )
}
